import React from 'react';
import URLCardAnalysis from '../KeywordAndURLAnalysis/pages/URLCardAnalysis';

interface IUrlAnalysisEmbed {
  /** 后端统一列表项原始数据（含 object_type / object_id / category / status ...） */
  ext: any;
  gameInfo: any;
  wholeGameInfo: any;
  userInfo: any;
  /** 隐藏筛选器底部操作按钮（确定 / 重置 / Stop），用于只读内嵌场景 */
  hideFilterOperateBtn?: boolean;
  /** 全部预览模式，预览模式下筛选器会有特殊样式调整（FilterBox: dbo-filterbox--all-preview） */
  allPreview?: boolean;
}

/**
 * AIInsightsReport 内嵌渲染：一次性 URL summary。
 *
 * 复用 KeywordAndURLAnalysis 下钻页的 URLCardAnalysis，以 isPreviews 纯展示模式挂载：
 *  - 只读：isCreator = false（禁用编辑 / 重置 / 保存等操作）
 *
 * 字段从后端统一列表项 ext 解析（object_id / short_url ...）。具体 key 待后端口径对齐后可能调整，
 * 此处做防御性兜底（object_id ?? task_id ?? id）。
 *
 * TODO（只读化，后续对接）：
 *  isPreviews 模式仍会渲染预览筛选器（UrlPreviewFilter），它是 filterValue 的初始化数据源，
 *  直接隐藏会导致 body 不渲染。要实现「筛选器不可动」需配合 FilterFixed 的只读/禁用模式，
 *  属于下钻组件侵入式改造，待后续处理。
 */
export default function UrlAnalysisEmbed({
  ext,
  gameInfo,
  wholeGameInfo,
  userInfo,
  hideFilterOperateBtn = true,
  allPreview = true,
}: IUrlAnalysisEmbed) {
  const leadId = ext?.lead_id;
  const shortId = ext?.short_url;

  return (
    <URLCardAnalysis
      gameInfo={gameInfo}
      wholeGameInfo={wholeGameInfo}
      userInfo={userInfo}
      isPreviews
      isCreator={false}
      leadId={leadId}
      shortId={shortId}
      hideFilterOperateBtn={hideFilterOperateBtn}
      allPreview={allPreview}
    />
  );
}
